<script setup lang="ts">
import { useField } from 'vee-validate'
import { computed } from 'vue'

const props = defineProps<{
  name: string
  label: string
  placeholder?: string
  validationRules?: string
  modelValue?: string | number
  disabled?: boolean
}>()

const { value, errorMessage, meta } = useField<string | number>(
  () => props.name,
  {
    rules: props.validationRules,
    initialValue: props.modelValue,
  },
  {
    syncVModel: true,
  },
)

const hasError = computed(() => !meta.valid && meta.validated)

</script>
<template>
  <div class="relative z-0 w-full pt-2">
    <input
      :id="name"
      v-model="value"
      :class="[
        'block p-4 pb-0 px-0 w-full text-sm sm:text-base bg-transparent border-0 border-b-2 appearance-none focus:outline-none focus:ring-0 peer',
        'disabled:cursor-not-allowed disabled:bg-gray-100',
        hasError ? 'border-red-300 focus:border-red-500' : 'border-indigo-200',
      ]"
      :disabled="disabled == true"
      :placeholder="placeholder || ' '"
    />
    <label
      :for="name"
      :class="[
        'absolute text-sm md:text-base duration-300 transform -translate-y-2 scale-75 top-4 origin-[0] peer-focus:start-0 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-2 peer-focus:scale-75 peer-focus:-translate-y-2 z-0 disabled:bg-gray-400',
        hasError
          ? 'text-red-500 peer-focus:text-red-600'
          : 'text-indigo-500 peer-focus:text-blue-600',
      ]"
    >
      {{ label }}
    </label>
    <span class="font-thin text-xs text-red-500">{{ errorMessage }} </span>
  </div>
</template>
